<article class=`str-item-card str-adaptive-card str-adaptive-card--${input.cardLayout} ${input.class}` ...input.testId>
    <div class="str-adaptive-card__top">
        <str-watch-icon
            page=input.page
            itemId=input.itemId
            iconSize="SMALL"
            itemCardWatch=input.itemCardWatch 
        />
        <if(input.isAjax)>
            <${input.link ? "a" : "span"} onClick("fetchCategoryListings", input.link) href=input.link _sp=input.sid
                data-track=input.trackingData>
                <str-ordered-properties-header ...input/>
            </>
        </if>
        <else-if(input.isQuickviewEnabled)>
            <span>
                <str-ordered-properties-header ...input/>
            </span>
        </else-if>
        <else>
            <${input.link ? "a" : "span"} href=input.link _sp=input.sid data-track=input.trackingData
                target=(input.openLinkInNewTab && "_blank")>
                <str-ordered-properties-header ...input/>
            </>
        </else>
    </div>
    <div.str-item-card__signals-container class="str-adaptive-card__bottom">
        <div.str-item-card__signals>
            <str-ordered-properties-content ...input/>
        </div>
        <if(input.entityOverflow)>
            <entity-overflow-button/>
        </if>
    </div>
</article>

<macro name="entity-overflow-button">
    <ebay-menu-button
        variant="overflow"
        reverse=true
        size="small"
        collapseOnSelect=true
        a11y-text=input.entityOverflow.icon?.accessibilityText>
        <for|entry| of=input.entityOverflow.menuItems?.entries>
            <@item>
                <str-textual-display ...entry.label/>
            </@item>
        </for>
    </ebay-menu-button>
</macro>
